export const TEXTS = {
  BANNER_GRACE_TEXT:
    'Деньги за подписку не списались. Вещание остановится в ближайшее время. Проверьте состояние карты.',
  BANNER_GRACE_SBBOL_TEXT:
    'Деньги за подписку не списались. Вещание остановится в ближайшее время. Проверьте состояние счета СберБизнес.',

  BANNER_UNPAID_TEXT: 'Вещание на адресах остановлено. Чтобы возобновить вещание, оплатите подписку.',
  BANNER_TRIAL_TEXT: 'Оплатите, чтобы вещание продолжалось. До конца тестового периода осталось ',
  BANNER_TRIAL_BY_TEXT: '. Чтобы пользоваться сервисом без ограничений, оплатите подписку.',
  BANNER_TRIAL_BY_COUNTDOWN_TEXT: 'До конца тестового периода осталось ',
  BANNER_TRIAL_KZ_MESSAGE_TEXT: 'Прошу выставить счет по завершению тестового периода',

  BUTTON_GO_TO_BILLING_VARIANT_TITLE: 'Оплатить подписку',
  BUTTON_GO_TO_BILLING_VARIANT_TITLE_TRIAL: 'Оплатить',

  BUTTON_TITLE_TRIAL_FOR_BY: 'У вас действует тестовый период. Мы вас никак не защищаем.',
};
